import React from "react";
import { Table, TableContainer, TableHead, TableRow, TableCell, TableBody, CircularProgress } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import moment from "moment";


const style = {
  overflow: 'hidden',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  maxWidth: '90vw',
  minWidth: '70vw',
  minHeight: '60vh',
  maxHeight: '90vh',
  bgcolor: 'background.paper',
  borderRadius: '1rem',
  boxShadow: 24,
  p: 4,
  display: 'flex',
  flexDirection: 'column',
  padding: '1rem',
  position: "absolute"
};

export class TimelineCardTodosDocumentos extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      tableData: [],
      isLoading: false
    }
  };

  componentDidMount() {
    this.getData()
  }

  getData = async () => {
    this.setState({ isLoading: true })
    const events = this.props.fatos.length > 0 ? this.props.fatos.map(valoresOcorrencias => valoresOcorrencias.ocorrencias).reduce((ocorrencias, values) => ocorrencias.concat(values, [])) : []
    if (events.length === 0) return
    this.setState({ isLoading: true })
    const newFatos = this.props.fatos.filter((object, index) => {
      return index === this.props.fatos.findIndex(value => object.fato_id === value.fato_id)
    }).filter(item => item.ocorrencias.length !== 0);
    const queryParams = {
      filters: JSON.stringify(newFatos),
      textFilter: this.props.textFilter,
      dataInicio: this.props.dataInicio,
      dataFim: this.props.dataFim,
      showUnread: this.props.showUnread,
    }
    const queryStringParams = new URLSearchParams(queryParams)
    const { data } = await this.props.api.get(`timeline/todos-documentos?${queryStringParams.toString()}`)
    const tableDataSanitized = data.reduce((acc, curr) => {
      const temp = {
        doc_id: curr.document_id,
        name: curr.boat,
        tipoDocumento: curr.tipo,
        fornecedor: curr.fornecedor,
        aprovacao: curr.aprov,
        pedidoReparo: curr.pr,
        link: `/mediateca?alertdoc=${curr.document_id}`,
        pendencia: curr.pendencias,
        data: moment(curr.dtaprox).format('DD/MM/YYYY')
      }
      acc.push(temp)
      return acc
    }, [])
    this.setState({ tableData: tableDataSanitized, isLoading: false })
  }

  onPressRow = (id) => {
    this.props.onSelectRow(id)
    this.props.onCloseCard()
  }

  render() {
    const { origin } = window.location
    return (
      <>
        <Modal
          open={this.props.showModal}
          onClose={this.props.onCloseCard}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <Box sx={style}>
            <header style={{ paddingBottom: "6px", borderBottom: "1px solid gray", flexDirection: 'row', display: 'flex', justifyContent: 'space-between' }}>
              <div>
                <h2 style={{ padding: 0, margin: 0, color: "#3f3f3f" }}>Detalhes</h2>
              </div>
              <div style={{ textAlign: 'end', padding: 0, margin: 0 }}>
                <CloseIcon onClick={this.props.onCloseCard} sx={{
                  ":hover": {
                    color: 'grey', backgrounColor: 'white'
                  }
                }} />
              </div>
            </header>
            <div style={{ display: 'flex', flexDirection: 'row', position: 'relative', overflowY: 'scroll', height: 'calc(100% - 72px)' }}>
              <TableContainer>
                <Table sx={{ width: '100%' }}>
                  <TableHead>
                    <TableRow>
                      <TableCell>Id</TableCell>
                      <TableCell>Fornecedor</TableCell>
                      <TableCell>Tipo</TableCell>
                      <TableCell>Data</TableCell>
                      <TableCell>Embarcação</TableCell>
                      <TableCell>Pendência ou Falha</TableCell>
                      <TableCell>Pedido de Reparo (PR)</TableCell>
                      <TableCell>Aprovação</TableCell>
                      <TableCell>Documento</TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {this.state.isLoading && <TableRow><TableCell component="th" align="center" colSpan={9}><CircularProgress /></TableCell></TableRow>}
                    {this.state.tableData.map((item, index) => (
                      <TableRow key={item.doc_id} onClick={() => this.onPressRow(item.doc_id)} style={{ cursor: 'pointer' }}>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.fornecedor || 'xxx'}</TableCell>
                        <TableCell>{item.tipoDocumento || 'xxx'}</TableCell>
                        <TableCell>{item.data || 'xxx'}</TableCell>
                        <TableCell>{item.name || 'xxx'}</TableCell>
                        <TableCell>{item.pendencia?.split('|').map(text => <>{text}<br /></>) || 'xxx'}</TableCell>
                        <TableCell>{item.pedidoReparo || 'xxx'}</TableCell>
                        <TableCell>{item.aprovacao || 'xxx'}</TableCell>
                        <TableCell>
                          <a style={{ color: '#0000EE' }} href={`viewer.html?p=${item.doc_id}`} target="_blank" onClick={(e) => e.stopPropagation()}>{`${origin}/viewer.html?p=${item.doc_id}`}</a>
                        </TableCell>
                      </TableRow>
                    ))}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
          </Box>
        </Modal>
      </>

    )
  }
}